import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AzureAuthService } from '../service/azure-auth.service';

@Component({
  selector: 'app-sso-callback',
  template: `<p>Autenticando via SSO... aguarde...</p>`
})
export class SsoCallbackComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AzureAuthService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const token = params.token;
      const userId = params.user;

      if (token) {
        this.authService.saveToken(token);
        this.authService.saveUser(userId);
        
        this.authService.getRequestInfos().subscribe(response => {
          this.authService.savePermissions(JSON.stringify(response.data.permissions));
          this.authService.saveClientes(JSON.stringify(response.data.clientes));
          this.authService.saveUsername(response.data.username);
        }, error => {
          console.error('Error fetching request infos:', error);
        });
        this.router.navigate(['/home']);
      } else {
        this.router.navigate(['/login']);
      }
    });
  }
}